<template>
  <div class="home">
    <div class="main">
      <div class="main_top">
        <video id="v1" autoplay loop muted>
          <source src="../../assets/img/bjsp.mp4" type="video/mp4" />
        </video>
        <Header @getLoginInfo="getLoginInfoFn"></Header>
        <!-- 搜索 -->
        <div class="inp">
          <h3></h3>
          <p>
            <span>全息多维信息探查</span>
            <span style="margin-left:17px;">微观实体运行分析</span>
            <!-- <span style="margin-left:17px;">产业发展动态监测</span> -->
          </p>
          <div class="inputPos"></div>
          <div class="inpBox">
            <input
              class="textField"
              v-model="params.companyName"
              type="text"
              @keyup.13="searchBtn()"
              placeholder="请输入企业名称"
            />
            <!-- <div class="searchBtn" @click="searchBtn">
              <img src="@/assets/img/search.png" alt />
            </div>-->
            <div class="advanSeachs" @click="searchBtn">查企业</div>
            <div class="advanSeach" @click="iflogin">高级筛选</div>
          </div>
        </div>
        <!-- 搜索后的 -->
        <!-- <div class="hind" v-show="hindBox">
          <ul>
            <li
              v-for="(item, index) in searchData"
              :key="index"
              @click="hindLi(item)"
              v-html="brightenKeyword(item.companyName)"
            ></li>
          </ul>
        </div>-->
      </div>
      <!-- 实时数据 -->
      <div class="main_bottom">
        <div class="main_box">
          <div>
            <div class="imgBox">
              <img src="../../assets/img/icon1.png" alt class="icon1" />
              <img src="../../assets/img/icon1_1.png" alt class="icon1_1" />
            </div>
            <h3>
              <vns
                :start="0"
                :end="Number(9100)"
                :times="40"
                :speed="50"
                :format="num =>  String(num).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')  + '万+'"
              />
            </h3>
            <span class="span">社会实体总量</span>
          </div>
          <div>
            <div class="imgBox">
              <img src="../../assets/img/icon2.png" class="icon2" alt />
            </div>
            <h3>
              <vns
                :start="0"
                :end="Number(20000000)"
                :times="40"
                :speed="50"
                :format="num =>  String(num).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')  + '万+'"
              />
            </h3>
            <span class="span">数据总量</span>
          </div>
          <div>
            <div class="imgBox">
              <img src="../../assets/img/icon3.png" class="icon3" alt />
              <img src="../../assets/img/icon3_1.png" class="icon3_1" alt />
              <img src="../../assets/img/icon3_2.png" class="icon3_2" alt />
              <img src="../../assets/img/icon3_3.png" class="icon3_3" alt />
            </div>
            <h3>
              <vns
                :start="0"
                :end="Number(50)"
                :times="40"
                :speed="50"
                :format="num =>  String(num).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')  + '+'"
              />
            </h3>
            <span class="span">企业数据维度</span>
          </div>
        </div>
        <div class="main_title">
          <h3>全能型数据分析平台，打通企业数据分析应用的全场景需求</h3>
          <span>截至{{timer}}</span>
        </div>
      </div>
      <!-- 轮播图 -->
      <div class="main_swiper">
        <el-carousel trigger="click" height="630px" :autoplay="true">
          <el-carousel-item>
            <div class="swiper_1">
              <div class="swiper_left">
                <h3>深挖数据价值，主动发现风险</h3>
                <p>基于大数据技术，依托人工智能、机器学习、数据可视化等先进的信息技术手段和数据挖掘算法，提供国内领先的、模块化的经济发展动态监测平台。</p>
              </div>
              <div class="swiper_right">
                <img src="../../assets/img/swiper/swiper1.png" class="swiper1" alt />
                <img
                  src="../../assets/img/swiper/cl1.png"
                  style="width:13px;height:17px;left:375px;top:145px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cl2.png"
                  style="width:14px;height:17px;left:426px;top:150px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/thin1.png"
                  style="width:2px;height:43px;left:356px;top:82px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cir1.png"
                  style="width:6px;height:6px;left:354px;top:120px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/thin1.png"
                  style="width:2px;height:43px;left:394px;top:99px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cir1.png"
                  style="width:5px;height:6px;left:395px;top:151px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cir1.png"
                  style="width:3px;height:3px;left:415px;top:137px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/thin1.png"
                  style="width:1px;height:43px;left:428px;top:62px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cir1.png"
                  style="width:4px;height:4px;left:441px;top:77px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cir1.png"
                  style="width:5px;height:5px;left:437px;top:114px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cir1.png"
                  style="width:5px;height:4px;left:460x;top:155px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/thin1.png"
                  style="width:2px;height:60px;left:470px;top:115px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/thin1.png"
                  style="width:2px;height:43px;left:501px;top:88px;"
                  class="position"
                  alt
                />
                <p class="p1"></p>
                <p class="p2"></p>
                <p class="p3"></p>
                <p class="p4"></p>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="swiper_1">
              <div class="swiper_left">
                <h3>内容丰富，依法合规</h3>
                <p>本产品数据来源于政府部门公开数据、企业公开信息、互联网大数据等，公司基于互联网+大数据+深度学习技术体系，充分利用机器学习算法、NLP文本分析和知识图谱等先进技术，清洗构建出企业全景信息。</p>
              </div>
              <div class="swiper_right">
                <img src="../../assets/img/swiper/swiper2.png" class="swiper1" alt />
                <img
                  src="../../assets/img/swiper/thin1.png"
                  style="width:2px;height:43px;left:283px;top:29px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/thin1.png"
                  style="width:1px;height:43px;left:323px;top:87px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/thin1.png"
                  style="width:2px;height:43px;left:362px;top:54px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/thin1.png"
                  style="width:2px;height:60px;left:387px;top:41px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cir1.png"
                  style="width:6px;height:6px;left:281px;top:67px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cir1.png"
                  style="width:5px;height:6px;left:290px;top:176px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cir1.png"
                  style="width:3px;height:3px;left:310px;top:162px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cir1.png"
                  style="width:3px;height:3px;left:337px;top:103px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cir1.png"
                  style="width:5px;height:5px;left:340px;top:83px;"
                  class="position"
                  alt
                />
                <img
                  src="../../assets/img/swiper/cir1.png"
                  style="width:5px;height:4px;left:355px;top:180px;"
                  class="position"
                  alt
                />
                <p class="l1"></p>
                <p class="l2"></p>
                <p class="l3"></p>
                <p class="l4"></p>
                <p class="l5"></p>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="swiper_1">
              <div class="swiper_left">
                <h3>经济分析，运行监测</h3>
                <p>市场主体数据是研究宏观经济的微观基础，是国民经济运行的“晴雨表”，通过大数据挖掘分析，对城市内的企业分布、产业结构、市场发展、资本流动等进行分析评估，为产业和区域经济的研究提供有力支撑。</p>
              </div>
              <div class="swiper_right">
                <img src="../../assets/img/swiper/swiper3.png" class="swiper1" alt />
                <div class="posi" style="top:223px;left:67px;">
                  <span style="top:10px;left:9px;"></span>
                  <span style="top:15px;left:5px;"></span>
                  <span style="top:14px;left:10px;"></span>
                  <span style="top:18px;left:9px;"></span>
                  <span style="top:22px;left:5px;"></span>
                  <span style="top:23px;left:9px;"></span>
                  <span style="top:26px;left:10px;"></span>
                  <span style="top:28px;left:9px;"></span>
                  <span style="top:21px;left:13px;"></span>
                  <span style="top:30px;left:5px;"></span>
                  <span style="top:45px;left:9px;"></span>
                  <span style="top:33px;left:5px;"></span>
                  <span style="top:34px;left:10px;"></span>
                  <span style="top:38px;left:9px;"></span>
                  <span style="top:46px;left:14px;"></span>
                  <span style="top:52px;left:5px;"></span>
                  <span style="top:63px;left:9px;"></span>
                  <span style="top:44px;left:5px;"></span>
                  <span style="top:66px;left:10px;"></span>
                  <span style="top:58px;left:9px;"></span>
                  <span style="top:81px;left:14px;"></span>
                  <span style="top:70px;left:5px;"></span>
                  <span style="top:115px;left:9px;"></span>
                  <span style="top:133px;left:5px;"></span>
                  <span style="top:134px;left:10px;"></span>
                  <span style="top:138px;left:9px;"></span>
                  <span style="top:141px;left:14px;"></span>
                  <span style="top:132px;left:5px;"></span>
                  <span style="top:133px;left:9px;"></span>
                  <span style="top:142px;left:5px;"></span>
                  <span style="top:124px;left:10px;"></span>
                  <span style="top:126px;left:9px;"></span>
                  <span style="top:127px;left:14px;"></span>
                  <span style="top:112px;left:5px;"></span>
                  <span style="top:105px;left:9px;"></span>
                  <span style="top:103px;left:5px;"></span>
                  <span style="top:104px;left:10px;"></span>
                  <span style="top:108px;left:9px;"></span>
                  <span style="top:101px;left:14px;"></span>
                  <span style="top:102px;left:5px;"></span>
                  <span style="top:103px;left:9px;"></span>
                  <span style="top:102px;left:5px;"></span>
                  <span style="top:94px;left:10px;"></span>
                  <span style="top:96px;left:9px;"></span>
                  <span style="top:97px;left:14px;"></span>
                  <span style="top:82px;left:5px;"></span>
                </div>
                <div class="posi" style="top:214px;right:32px;">
                  <span style="top:10px;left:9px;"></span>
                  <span style="top:15px;left:5px;"></span>
                  <span style="top:14px;left:10px;"></span>
                  <span style="top:18px;left:9px;"></span>
                  <span style="top:22px;left:5px;"></span>
                  <span style="top:23px;left:9px;"></span>
                  <span style="top:26px;left:10px;"></span>
                  <span style="top:28px;left:9px;"></span>
                  <span style="top:21px;left:13px;"></span>
                  <span style="top:30px;left:5px;"></span>
                  <span style="top:45px;left:9px;"></span>
                  <span style="top:33px;left:5px;"></span>
                  <span style="top:34px;left:10px;"></span>
                  <span style="top:38px;left:9px;"></span>
                  <span style="top:46px;left:14px;"></span>
                  <span style="top:52px;left:5px;"></span>
                  <span style="top:63px;left:9px;"></span>
                  <span style="top:44px;left:5px;"></span>
                  <span style="top:66px;left:10px;"></span>
                  <span style="top:58px;left:9px;"></span>
                  <span style="top:81px;left:14px;"></span>
                  <span style="top:70px;left:5px;"></span>
                  <span style="top:115px;left:9px;"></span>
                  <span style="top:133px;left:5px;"></span>
                  <span style="top:134px;left:10px;"></span>
                  <span style="top:138px;left:9px;"></span>
                  <span style="top:141px;left:14px;"></span>
                  <span style="top:132px;left:5px;"></span>
                  <span style="top:133px;left:9px;"></span>
                  <span style="top:142px;left:5px;"></span>
                  <span style="top:124px;left:10px;"></span>
                  <span style="top:126px;left:9px;"></span>
                  <span style="top:127px;left:14px;"></span>
                  <span style="top:112px;left:5px;"></span>
                  <span style="top:105px;left:9px;"></span>
                  <span style="top:103px;left:5px;"></span>
                  <span style="top:104px;left:10px;"></span>
                  <span style="top:108px;left:9px;"></span>
                  <span style="top:101px;left:14px;"></span>
                  <span style="top:102px;left:5px;"></span>
                  <span style="top:103px;left:9px;"></span>
                  <span style="top:102px;left:5px;"></span>
                  <span style="top:94px;left:10px;"></span>
                  <span style="top:96px;left:9px;"></span>
                  <span style="top:97px;left:14px;"></span>
                  <span style="top:82px;left:5px;"></span>
                </div>
                <div class="posi" style="bottom:116px;left:320px;">
                  <span style="top:10px;left:9px;"></span>
                  <span style="top:15px;left:5px;"></span>
                  <span style="top:14px;left:10px;"></span>
                  <span style="top:18px;left:9px;"></span>
                  <span style="top:22px;left:5px;"></span>
                  <span style="top:23px;left:9px;"></span>
                  <span style="top:26px;left:10px;"></span>
                  <span style="top:28px;left:9px;"></span>
                  <span style="top:21px;left:13px;"></span>
                  <span style="top:30px;left:5px;"></span>
                  <span style="top:45px;left:9px;"></span>
                  <span style="top:33px;left:5px;"></span>
                  <span style="top:34px;left:10px;"></span>
                  <span style="top:38px;left:9px;"></span>
                  <span style="top:46px;left:14px;"></span>
                  <span style="top:52px;left:5px;"></span>
                  <span style="top:63px;left:9px;"></span>
                  <span style="top:44px;left:5px;"></span>
                  <span style="top:66px;left:10px;"></span>
                  <span style="top:58px;left:9px;"></span>
                  <span style="top:81px;left:14px;"></span>
                  <span style="top:70px;left:5px;"></span>
                  <span style="top:115px;left:9px;"></span>
                  <span style="top:133px;left:5px;"></span>
                  <span style="top:134px;left:10px;"></span>
                  <span style="top:138px;left:9px;"></span>
                  <span style="top:141px;left:14px;"></span>
                  <span style="top:132px;left:5px;"></span>
                  <span style="top:133px;left:9px;"></span>
                  <span style="top:142px;left:5px;"></span>
                  <span style="top:124px;left:10px;"></span>
                  <span style="top:126px;left:9px;"></span>
                  <span style="top:127px;left:14px;"></span>
                  <span style="top:112px;left:5px;"></span>
                  <span style="top:105px;left:9px;"></span>
                  <span style="top:103px;left:5px;"></span>
                  <span style="top:104px;left:10px;"></span>
                  <span style="top:108px;left:9px;"></span>
                  <span style="top:101px;left:14px;"></span>
                  <span style="top:102px;left:5px;"></span>
                  <span style="top:103px;left:9px;"></span>
                  <span style="top:102px;left:5px;"></span>
                  <span style="top:94px;left:10px;"></span>
                  <span style="top:96px;left:9px;"></span>
                  <span style="top:97px;left:14px;"></span>
                  <span style="top:82px;left:5px;"></span>
                </div>
                <div class="posi" style="top:47px;left:326px;">
                  <span style="top:10px;left:9px;"></span>
                  <span style="top:15px;left:5px;"></span>
                  <span style="top:14px;left:10px;"></span>
                  <span style="top:18px;left:9px;"></span>
                  <span style="top:22px;left:5px;"></span>
                  <span style="top:23px;left:9px;"></span>
                  <span style="top:26px;left:10px;"></span>
                  <span style="top:28px;left:9px;"></span>
                  <span style="top:21px;left:13px;"></span>
                  <span style="top:30px;left:5px;"></span>
                  <span style="top:45px;left:9px;"></span>
                  <span style="top:33px;left:5px;"></span>
                  <span style="top:34px;left:10px;"></span>
                  <span style="top:38px;left:9px;"></span>
                  <span style="top:46px;left:14px;"></span>
                  <span style="top:52px;left:5px;"></span>
                  <span style="top:63px;left:9px;"></span>
                  <span style="top:44px;left:5px;"></span>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 高级查询弹框 -->
      <el-dialog
        title="高级查询"
        :visible.sync="dialogVisible"
        width="40%"
        :before-close="handleClose"
        center
      >
        <div class="dialog_title">配置如下查询条件，更精准高效的帮助您找到目标企业</div>
        <div class="advanSeachBox">
          <div class="searchBox_1" v-if="selectedData.length>0">
            <div class="searchBox_1_left">已选条件：</div>
            <div :class="showForm?'searchBox_1_right_auto':'searchBox_1_right'">
              <div v-for="(v,i) in selectedData" :key="i">
                <p>
                  <span>{{v.show?v.type+':':''}}</span>
                  {{v.label}}
                </p>
                <i class="el-icon-close" @click="remove(v,i)"></i>
              </div>
            </div>
          </div>
          <div class="btn-show" v-if="selectedData.length>10">
            <el-button type="text" @click="showForm = !showForm">
              {{ showForm ? '收起' : '展开' }}
              <i
                :class="[showForm ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
              ></i>
            </el-button>
          </div>
          <div class="searchBox_2">
            <div class="searchBox_2_left">
              <div class="searchBox_2_title">所属行业：</div>
              <el-cascader
                ref="industry"
                collapse-tags
                v-model="params.industry_id"
                :options="industryData"
                :props="industry_props"
                :show-all-levels="false"
                @change="industryHandleChange"
                @expand-change="changeIndustry"
              ></el-cascader>
            </div>
            <div class="searchBox_2_right">
              <div class="searchBox_2_title">登记城市：</div>
              <el-cascader
                ref="city"
                collapse-tags
                v-model="params.region_id"
                :options="region"
                :show-all-levels="false"
                :props="city_props"
                @change="regionChange"
              ></el-cascader>
            </div>
          </div>
          <div class="searchBox_3">
            <div class="searchBox_3_right">
              <el-radio-group v-model="params.managementForms">
                <p>登记状态：</p>
                <el-radio
                  :label="v.orderNum"
                  v-for="(v,i) in management_forms"
                  :key="i"
                  @change="changeRideo(v,'登记状态','managementForms')"
                >{{v.showName}}</el-radio>
              </el-radio-group>
              <el-radio-group v-model="params.registrationDateRange">
                <p>成立年限：</p>
                <el-radio
                  :label="v.showName"
                  v-for="(v,i) in ageLimitData"
                  :key="i"
                  @change="changeRideo(v,'成立年限','registrationDateRange')"
                >{{v.showName}}</el-radio>
              </el-radio-group>
              <el-radio-group v-model="params.registered_capital">
                <p>注册资本：</p>
                <el-radio
                  :label="v.showName"
                  v-for="(v,i) in capitalData"
                  :key="i"
                  @change="changeRideo(v,'注册资本','registered_capital')"
                >{{v.showName}}</el-radio>
              </el-radio-group>
              <el-radio-group v-model="params.capital_type_id">
                <p>资本类型：</p>
                <el-radio
                  :label="v.orderNum"
                  v-for="(v,i) in capital_type"
                  :key="i"
                  @change="changeRideo(v,'资本类型','capital_type_id')"
                >{{v.showName}}</el-radio>
              </el-radio-group>
              <el-radio-group v-model="params.company_type_id">
                <p>企业类型：</p>
                <el-radio
                  :label="v.orderNum"
                  v-for="(v,i) in company_type"
                  :key="i"
                  @change="changeRideo(v,'企业类型','company_type_id')"
                >{{v.showName}}</el-radio>
              </el-radio-group>
              <el-radio-group v-model="params.organization_id">
                <p>组织机构：</p>
                <el-radio
                  :label="v.orderNum"
                  v-for="(v,i) in organization"
                  :key="i"
                  @change="changeRideo(v,'组织机构','organization_id')"
                >{{v.showName}}</el-radio>
              </el-radio-group>
              <el-radio-group v-model="params.social">
                <p>社保人数：</p>
                <el-radio
                  :label="v.showName"
                  v-for="(v,i) in  socialData"
                  :key="i"
                  @change="changeRideo(v,'社保人数','social')"
                >{{v.showName}}</el-radio>
              </el-radio-group>
              <el-radio-group v-model="params.list_type_id">
                <p>上市情况：</p>
                <el-radio
                  :label="v.orderNum"
                  v-for="(v,i) in  list_type"
                  :key="i"
                  @change="changeRideo(v,'上市情况','list_type_id')"
                >{{v.showName}}</el-radio>
              </el-radio-group>
              <el-radio-group v-model="params.financing">
                <p>融资类型：</p>
                <el-radio
                  :label="v.orderNum"
                  v-for="(v,i) in  financing"
                  :key="i"
                  @change="changeRideo(v,'融资类型','financing')"
                >{{v.showName}}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <!-- <div class="searchBox_4">
            <div class="searchBox_4_left">精准条件：</div>
            <div class="searchBox_4_right">
              <div>
                <el-select
                  v-model="params.invite"
                  placeholder="用工招聘"
                  @change="changeSelect(params.invite,'invite')"
                >
                  <el-option
                    v-for="item in inviteData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="params.tendering"
                  placeholder="招标投标"
                  @change="changeSelect(params.tendering,'tendering')"
                >
                  <el-option
                    v-for="item in tenderingData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="params.ratepayer"
                  placeholder="一般纳税人"
                  @change="changeSelect(params.ratepayer,'ratepayer')"
                >
                  <el-option
                    v-for="item in ratepayerData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="params.patent"
                  placeholder="专利信息"
                  @change="changeSelect(params.patent,'patent')"
                >
                  <el-option
                    v-for="item in patentData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="params.brand"
                  placeholder="商标信息"
                  @change="changeSelect(params.brand,'brand')"
                >
                  <el-option
                    v-for="item in brandData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="params.copyright"
                  placeholder="作品著作权"
                  @change="changeSelect(params.copyright,'copyright')"
                >
                  <el-option
                    v-for="item in copyrightData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                  ></el-option>
                </el-select>
              </div>
              <div class="select_box">
                <el-select
                  v-model="params.history"
                  placeholder="历史变更"
                  @change="changeSelect(params.history,'history')"
                >
                  <el-option
                    v-for="item in historyData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="params.promise"
                  placeholder="失信信息"
                  @change="changeSelect(params.promise,'promise')"
                >
                  <el-option
                    v-for="item in promiseData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="params.judgment"
                  placeholder="裁判文书"
                  @change="changeSelect(params.judgment,'judgment')"
                >
                  <el-option
                    v-for="item in judgmentData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="params.court"
                  placeholder="法院公告"
                  @change="changeSelect(params.court,'court')"
                >
                  <el-option
                    v-for="item in courtData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="params.punish"
                  placeholder="行政处罚"
                  @change="changeSelect(params.punish,'punish')"
                >
                  <el-option
                    v-for="item in punishData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="params.abnormal "
                  placeholder="经营异常"
                  @change="changeSelect(params.abnormal,'abnormal')"
                >
                  <el-option
                    v-for="item in abnormalData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    size="mini"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div> -->
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            :type="selectedData.length>0 ?'primary':'info'"
            @click="reset"
            style="width:106px;height:36px;"
          >全部重置</el-button>
          <el-button
            type="primary"
            class="langBtn"
            style="width:96px;height:36px;"
            @click="gjsearchBtn"
          >查询</el-button>
        </span>
      </el-dialog>
    </div>
    <Footer style="margin-top:0;"></Footer>
  </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import api from "@/../static/common/api/api.js";
import vns from "vue-number-scroll";
import magic from "@/../static/common/magic.js";
export default {
  props: {},
  components: {
    Header,
    Footer,
    vns
  },
  data() {
    let _self = this;
    return {
      companyName: "", //传参
      list: [], //原本数据
      showForm: false, //展开收起按钮
      hindBox: false,
      dialogVisible: false,
      loginInfo: "",
      value: [],
      selectedData: [], //已选条件
      params: {}, //已选参数
      params_name: {}, //已选参数名称
      industry_props: {
        //所属行业props配置
        // lazy: true,
        multiple: true,
        // emitPath: false,
        children: "childrenList",
        // expandTrigger: "hover",
        // checkStrictly: true,
        value: "industry_id",
        label: "industry_name"

        // lazyLoad(node, resolve) {
        //   const level = node.level;
        //   const id = node.value;
        //   api.imap_getNextIndustryDot(id).then(res => {
        //     let _industry = res.data;
        //     let node = _self.changeBool(_self, _industry, "leaf");
        //     for (let i = 0; i < _industry.length; i++) {
        //       _self.industryData2.push(_industry[i]);
        //     }
        //     resolve(_industry);
        //   });
        // }
      },
      city_props: {
        //登记城市props配置
        // lazy: true,
        multiple: true,
        // emitPath: false,
        children: "childrenList",
        // expandTrigger: "hover",
        value: "region_id",
        label: "regin_name"
        // lazyLoad(node, resolve) {
        //   const level = node.level;
        //   const id = node.value;
        //   api.getNextRegionData(id).then(res => {
        //     let _region = res.data;
        //     let node = _self.changeBool(_self, _region, "leaf");
        //     for (let i = 0; i < _region.length; i++) {
        //       _self.region2.push(_region[i]);
        //     }
        //     resolve(_region);
        //   });
        // }
      },
      management_forms: [], //高级查询登记状态
      industryData: [], //所属行业数据-第一级
      industryData2: [], //所属行业数据-二三级
      region: [], // 所在城市数据
      region2: [], // 所在城市数据二三级
      company_type: [], //企业类型
      capital_type: [], //资本类型
      list_type: [], //上市情况
      organization: [], // 组织机构
      financing: [], // 融资信息
      timer: "", //当前时间
      inviteData: [
        //用工招聘
        {
          value: 0,
          label: "有用工招聘"
        },
        {
          value: 1,
          label: "无用工招聘"
        }
      ],
      tenderingData: [
        //招标投标
        {
          value: 0,
          label: "有招标投标"
        },
        {
          value: 1,
          label: "无招标投标"
        }
      ],
      ratepayerData: [
        //纳税
        {
          value: 0,
          label: "是一般纳税人"
        },
        {
          value: 1,
          label: "其他纳税人"
        }
      ],
      patentData: [
        //专利
        {
          value: 0,
          label: "有专利信息"
        },
        {
          value: 1,
          label: "无专利信息"
        }
      ],
      brandData: [
        //品牌
        {
          value: 0,
          label: "有品牌信息"
        },
        {
          value: 1,
          label: "无品牌信息"
        }
      ],
      copyrightData: [
        //作品著作权
        {
          value: 0,
          label: "有著作权"
        },
        {
          value: 1,
          label: "无著作权"
        }
      ],
      historyData: [
        //历史变更
        {
          value: 0,
          label: "有历史变更"
        },
        {
          value: 1,
          label: "无历史变更"
        }
      ],
      promiseData: [
        //失信信息
        {
          value: 0,
          label: "有失信信息"
        },
        {
          value: 1,
          label: "无失信信息"
        }
      ],
      judgmentData: [
        //裁判文书
        {
          value: 0,
          label: "有裁判文书"
        },
        {
          value: 1,
          label: "无裁判文书"
        }
      ],
      courtData: [
        //法院公告
        {
          value: 0,
          label: "有法院公告"
        },
        {
          value: 1,
          label: "无法院公告"
        }
      ],
      punishData: [
        //行政处罚
        {
          value: 0,
          label: "有行政处罚"
        },
        {
          value: 1,
          label: "无行政处罚"
        }
      ],
      abnormalData: [
        //经营异常
        {
          value: 0,
          label: "有经营异常"
        },
        {
          value: 1,
          label: "无经营异常"
        }
      ],
      searchBox3_data: [
        "成立年限：",
        "登记状态：",
        "注册资本：",
        "资本类型：",
        "企业类型：",
        "社保人数：",
        "上市情况："
      ],
      totalCount: 0,

      ageLimitData: [
        //成立年限
        // { orderNum: "", showName: "全部" },
        { orderNum: 1, showName: "0-1年" },
        { orderNum: 2, showName: "1-3年" },
        { orderNum: 3, showName: "3-5年" },
        { orderNum: 4, showName: "5-10年" },
        { orderNum: 5, showName: "10-15年" },
        { orderNum: 6, showName: "10年以上" }
      ],
      capitalData: [
        // 注册资本
        // { orderNum: "", showName: "全部" },
        { orderNum: 1, showName: "0-100万" },
        { orderNum: 2, showName: "100-500万" },
        { orderNum: 3, showName: "500-1000万" },
        { orderNum: 4, showName: "1000-3000万" },
        { orderNum: 5, showName: "3000-5000万" },
        { orderNum: 6, showName: "5000万以上" }
      ],
      capitalTypeData: [
        // 资本类型
      ],
      socialData: [
        //社保人数
        { orderNum: 1, showName: "1-10人" },
        { orderNum: 2, showName: "10-20人" },
        { orderNum: 3, showName: "20-100人" },
        { orderNum: 4, showName: "100-500人" },
        { orderNum: 5, showName: "500-1000人" },
        { orderNum: 6, showName: "1000人以上" }
      ],
      marketData: [
        //上市情况
        { orderNum: 1, showName: "A股" },
        { orderNum: 2, showName: "中概股" },
        { orderNum: 3, showName: "港股" },
        { orderNum: 4, showName: "科创板" },
        { orderNum: 5, showName: "新三板" },
        { orderNum: 6, showName: "新四板" }
      ]
    };
  },
  computed: {
    searchData() {
      let companyName = this.params.companyName;
      if (companyName) {
        return this.list.filter(product => {
          return Object.keys(product).some(function(key) {
            return (
              String(product[key])
                // toLowerCase() 方法用于把字符串转换为小写。
                // .toLowerCase()
                // indexOf() 方法可返回某个指定的字符串值在字符串中首次出现的位置。
                .indexOf(companyName) > -1
            );
          });
        });
      }
    }
  },
  methods: {
    //获取header返回来的登录信息
    getLoginInfoFn(val) {
      this.loginInfo = val;
    },
    iflogin() {
      var that = this;
      magic.loginOrRights(2).then(res => {
        if (!res) {
          that.$message.error("请您登录！");
        } else {
          api.weighterRights(2).then(res => {
            if (res.data) {
              that.dialogVisible = true;
            } else {
              that.$message.error("请您购买！");
            }
          });
        }
      });
    },

    // 关键字高亮
    brightenKeyword(val) {
      if (
        val.indexOf(this.params.companyName) !== -1 &&
        this.params.companyName !== ""
      ) {
        return val.replace(
          this.params.companyName,
          "<font color='red'><B>" + this.params.companyName + "</B></font>"
        );
      } else {
        return val;
      }
    },

    // 点击搜索列表
    // hindLi(val) {
    //   let _this = this;
    //   let creditCode = val.creditCode;
    //   let dbcode = val.dbCode;
    //   let companyName = val.companyName;
    //   if (this.loginInfo && this.loginInfo.token) {
    //     let productId = dbcode == 2 ? 0 : 1;
    //     api.weighterRights(productId).then(res => {
    //       if (res.code == 0) {
    //         let bool = res.data;
    //         if (bool) {
    //           //true为有权限
    //           if (dbcode == 2) {
    //             //上市公司
    //             let { href } = this.$router.resolve({
    //               path: `/searchPage`,
    //               query: {
    //                 creditCode
    //               }
    //             });
    //             window.open(href, "_blank");
    //             _this.hindBox = false;
    //           } else {
    //             // 医药公司
    //             let { href } = this.$router.resolve({
    //               path: `/searchPage`,
    //               query: {
    //                 creditCode
    //               }
    //             });
    //             sessionStorage.setItem(
    //               "companyName",
    //               JSON.stringify(companyName)
    //             );
    //             window.open(href, "_blank");
    //             _this.hindBox = false;
    //           }
    //           // 埋点
    //           try {
    //             //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
    //             //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
    //             LogCollection.send(9);
    //           } catch (e) {}
    //         } else {
    //           _this.$message.error("您没有权限！");
    //         }
    //       }
    //     });
    //   } else {
    //     this.$message.error("请您登录！");
    //   }
    // },
    // 搜索内容框显示
    inputFunc() {
      if (this.params.companyName.length > 0) {
        this.hindBox = true;
      } else {
        this.hindBox = false;
      }
    },
    // 获取数据
    getFiveCompany() {
      api.indexSearch(encodeURI(this.params.companyName)).then(res => {
        this.list = res.data;
        // console.log(this.list, "list");
      });
    },
    // 获取数据实时总量
    getTotalCount() {
      api.getTotalCount().then(res => {
        this.totalCount = res.data;
      });
    },
    // 获取高级查询数据
    getSearchData() {
      let _this = this;
      api.getSearchData().then(res => {
        this.management_forms = [
          // { orderNum: 0, showName: "全部" },
          ...res.data.management_forms
        ];
        this.company_type = res.data.company_type;
        this.capital_type = res.data.capital_type;

        this.list_type = res.data.list_type;
        this.organization = res.data.organization;
        this.financing = res.data.financing;
        this.industryData = res.data.industry;
        // this.industryData = _this.changeBool(_this, res.data.industry, "leaf");

        this.region = res.data.region;
        // this.region = _this.changeBool(_this, res.data.region, "leaf");
      });
    },
    // 搜索
    searchBtn() {
      // 埋点

      var that = this;
      magic.loginOrRights(2).then(res => {
        if (!res) {
          that.$message.error("请您登录！");
        } else {
          api.weighterRights(2).then(res => {
            if (res.data) {
              if (
                that.params.companyName != undefined &&
                that.params.companyName != ""
              ) {
                try {
                  LogCollection.contents["keywords"] = this.params.companyName;
                  //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
                  //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
                  LogCollection.send(9);
                } catch (e) {}
                that.$router.push({
                  name: "searchPage",
                  params: {companyName:that.params.companyName}
                });
              } else {
                that.$message.error("请输入企业名称!");
              }
            } else {
              that.$message.error("请您购买！");
            }
          });
        }
      });
    },
    // 高级搜索
    gjsearchBtn() {
      if (this.selectedData.length > 0) {
        delete this.params.companyName;
        // 埋点
        // try {
        //   LogCollection.contents["keywords"] = this.params.companyName
        //     ? this.params.companyName
        //     : "";
        //   //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //   //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        //   LogCollection.send(9);
        // } catch (e) {}
        var arr = [],
          arrs = [];
        if (this.params.industry_id) {
          this.params.industry_id.forEach((v, i) => {
            arr.push(v[v.length - 1]);
          });
          this.params.industry_id = arr.join(",");
        }
        if (this.params.region_id) {
          this.params.region_id.forEach((v, i) => {
            arrs.push(v[v.length - 1]);
          });

          this.params.region_id = arrs.join(",");
        }
        this.$router.push({
          name: "searchPage",
          params: this.params
        });
      } else {
        this.$message.error("请选择查询条件！");
      }
    },
    handleClose(done) {
      this.dialogVisible = false;
    },
    changeIndustry() {
      //  this.industryData.forEach((v, i) => {
      //     v.disabled = false;
      //   });
    },
    // 行业事件
    industryHandleChange(values) {
      var arrs = [];
      var parent = [];
      values.forEach((v, i) => {
        arrs.push(v[v.length - 1]);
        parent.push(v[0]);
      });
      // this.params.industry_id = arr;
      parent = Array.from(new Set(parent));
      arrs = Array.from(new Set(arrs));
      if (values == undefined) return;
      let value = values[values.length - 1];
      let obj = {
        type: "行业",
        types: "industry_id",
        show: true
      };
      obj.label =
        this.$refs["industry"].getCheckedNodes().length > 0
          ? this.$refs["industry"].getCheckedNodes()[0].label + "..."
          : "";
      if (parent.length > 1) {
        // 清空级联选择器选中状态
        this.$message.error("只能选择一项行业分类！");
        this.params.industry_id = [];
        this.$refs["industry"].activePath = [];
        for (let i = 0; i < this.selectedData.length; i += 1) {
          if (this.selectedData[i].type === obj.type) {
            this.selectedData.splice(this.selectedData[i], 1);
            return;
          }
        }
      }
      if (!this.$refs["industry"].getCheckedNodes()[0]) {
        for (let i = 0; i < this.selectedData.length; i += 1) {
          if (this.selectedData[i].type === obj.type) {
            this.selectedData.splice(this.selectedData[i], 1);
            return;
          }
        }
      }

      // this.industryData2.forEach((v, i) => {
      //   if (v.industry_id == value) {
      //     obj.label = v.industry_name;
      //   }
      // });
      for (let i = 0; i < this.selectedData.length; i += 1) {
        if (this.selectedData[i].type === obj.type) {
          this.selectedData[i].label = obj.label;
          return;
        }
      }

      this.selectedData.unshift(obj);
      if (this.params.industry_id.length != 0) {
        let arr = this.$refs["industry"].getCheckedNodes()[0].pathLabels;
        this.params.industry_name = arr.pop();
      }
    },

    // 城市事件
    regionChange(values) {
      var arrs = [];
      var parent = [];
      values.forEach((v, i) => {
        arrs.push(v[v.length - 1]);
        parent.push(v[0]);
      });
      parent = Array.from(new Set(parent));
      arrs = Array.from(new Set(arrs));
      if (values == undefined) return;
      let value = values[values.length - 1];
      let obj = {
        type: "城市",
        types: "region_id",
        show: true
      };
      obj.label =
        this.$refs["city"].getCheckedNodes().length > 0
          ? this.$refs["city"].getCheckedNodes()[0].label + "..."
          : "";
      if (parent.length > 1) {
        // 清空级联选择器选中状态
        this.$message.error("只能选择一项地区！");
        this.params.region_id = [];
        this.$refs["city"].activePath = [];
        for (let i = 0; i < this.selectedData.length; i += 1) {
          if (this.selectedData[i].type === obj.type) {
            this.selectedData.splice(this.selectedData[i], 1);
            return;
          }
        }
      }
      // this.region2.forEach((v, i) => {
      //   if (v.region_id == value) {
      //     obj.label = v.regin_name;
      //   }
      // });
      if (!this.$refs["city"].getCheckedNodes()[0]) {
        for (let i = 0; i < this.selectedData.length; i += 1) {
          if (this.selectedData[i].type === obj.type) {
            this.selectedData.splice(this.selectedData[i], 1);
            return;
          }
        }
      }
      for (let i = 0; i < this.selectedData.length; i += 1) {
        if (this.selectedData[i].type === obj.type) {
          this.selectedData[i].label = obj.label;
          return;
        }
      }
      this.selectedData.unshift(obj);
      if (this.params.region_id.length != 0) {
        let arr = this.$refs["city"].getCheckedNodes()[0].pathLabels;
        this.params.region_name = arr.pop();
      }
    },
    //单选事件
    changeRideo(data, type, types) {
      let obj = {
        label: data.label ? data.label : data.showName,
        type,
        types,
        show: true
      };
      for (let i = 0; i < this.selectedData.length; i += 1) {
        if (this.selectedData[i].type === type) {
          this.selectedData[i].label = obj.label;
          return;
        }
      }
      this.selectedData.unshift(obj);
    },
    //select事件
    changeSelect(data, types) {
      let arr = [];
      let obj = {
        types,
        show: false
      };
      switch (types) {
        case "invite":
          arr = this.inviteData;
          break;
        case "tendering":
          arr = this.tenderingData;
          break;
        case "ratepayer":
          arr = this.ratepayerData;
          break;
        case "patent":
          arr = this.patentData;
          break;
        case "brand":
          arr = this.brandData;
          break;
        case "copyright":
          arr = this.copyrightData;
          break;
        case "history":
          arr = this.historyData;
          break;
        case "promise":
          arr = this.promiseData;
          break;
        case "judgment":
          arr = this.judgmentData;
          break;
        case "court":
          arr = this.courtData;
          break;
        case "punish":
          arr = this.punishData;
          break;
        case "abnormal":
          arr = this.abnormalData;
          break;
      }
      obj.label = arr.find(item => {
        return item.value === data;
      }).label;
      for (let i = 0; i < this.selectedData.length; i += 1) {
        if (this.selectedData[i].types === types) {
          this.selectedData[i].label = obj.label;
          return;
        }
      }
      this.selectedData.unshift(obj);
    },
    //删除事件
    remove(v, i) {
      this.selectedData.splice(i, 1);
      this.params[v.types] = null;
    },
    //重置事件
    reset() {
      if (this.selectedData.length > 0) {
        this.selectedData = [];
        this.params = {};
      }
    },
    //将leaf里的字符串类型转成bool类型
    changeBool(_this, arr, val) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].childrenList.length) {
          _this.changeBool(arr[i].childrenList, val);
        } else {
          if (arr[i].hasOwnProperty(val)) {
            arr[i][val] = arr[i][val] == "false" ? "" : true;
          }
        }
      }
      return arr;
    }
  },
  created() {},
  mounted() {
    this.getTotalCount();
    this.getSearchData();
    this.timer = magic.getTimer();
  },
  watch: {
    "params.companyName": function() {
      this.getFiveCompany();
    }
  }
};
</script>
<style scoped lang="less">
.home {
  width: 100%;
  height: 100%;
}
.main {
  width: 100%;
  height: auto;
  .main_top {
    width: 100%;
    height: 668px;
    // background: url("../../assets/img/8.png") no-repeat top left;
    // background-position: center 0;
    // background-size: cover;
    // 搜索
    .inp {
      display: flex;
      flex-direction: column;
      text-align: center;
      h3 {
        margin-top: 220px;
        font-size: 56px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
      }
      p {
        margin-top: 31px;
        font-size: 31px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: #ffffff;
      }
      .inputPos {
        width: 811px;
        height: 60px;
        background: #b2ceff;
        opacity: 0.1;
        border-radius: 2px;
        margin: 0 auto;
        margin-top: 65px;
      }
      .inpBox {
        margin: 0 auto;
        transform: translate(0%, -110%);
        width: 801px;
        height: 50px;
        display: flex;
        justify-content: space-between;

        .textField {
          width: 729px;
          height: 50px;
          background: #fff;
          border-radius: 2px;
          border: none;
          text-indent: 20px;
          font-size: 16px;
          font-weight: 400;
        }
        .searchBtn {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          right: 120px;
          top: 37%;
          img {
            width: 16px;
            height: 16px;
          }
        }
        .advanSeachs {
          margin-left: 5px;
          width: 110px;
          height: 50px;
          background: #339bff;
          border-radius: 2px;
          color: #fff;
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        .advanSeach {
          margin-left: 5px;
          width: 40px;
          color: #fff;
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          line-height: 22px;
        }
      }
    }
    // 搜索后
    .hind {
      margin-top: -43px;
      display: flex;
      justify-content: center;
      align-items: center;
      ul {
        width: 801px;
        height: auto;
        background: #fff;
        li:first-child {
          padding-top: 7px;
        }
        li:last-child {
          padding-bottom: 7px;
        }
        li {
          padding-left: 20px;
          height: 25px;
          line-height: 25px;
          font-size: 14px;
        }
        li:hover {
          background: #b2ceff;
          cursor: pointer;
        }
      }
    }
  }
  // 库
  .main_bottom {
    height: 630px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    margin: 0 auto;
    background: #fff;
    .main_title {
      width: 943px;
      height: auto;
      display: flex;
      align-items: center;
      flex-direction: column;
      h3 {
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #1a1a1a;
        line-height: 43px;
        text-align: center;
        width: 100%;
      }
      span {
        margin-top: 27px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #808080;
        line-height: 15px;
        text-align: center;
      }
    }
    .main_box {
      display: flex;
      justify-content: space-between;
      width: 1000px;
      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        h3 {
          font-size: 42px;
          font-family: Arial;
          font-weight: bold;
          color: #000000;
          padding: 10px 40px;
        }
        .span {
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
        }
        .imgBox {
          position: relative;
          .icon1 {
            width: 160px;
            height: auto;
          }
          .icon2 {
            width: 202px;
            height: auto;
          }
          .icon3 {
            width: 173px;
            height: 150px;
          }
          .icon1_1 {
            width: 57px;
            height: 47px;
            position: absolute;
            -webkit-animation: ai 3s linear 0s infinite;
            animation: ai 3s linear 0s infinite;
            left: 37px;
            top: -17px;
          }
          .icon3_1 {
            width: 32px;
            height: 39px;
            position: absolute;
            -webkit-animation: ai 2s linear 0s infinite;
            animation: ai 2s linear 0s infinite;
            top: -25px;
            left: 80px;
          }
          .icon3_2 {
            width: 41px;
            height: 49px;
            position: absolute;
            -webkit-animation: ai 3s linear 0s infinite;
            animation: ai 3s linear 0s infinite;
            left: 30px;
            top: 16px;
          }
          .icon3_3 {
            width: 53px;
            height: 64px;
            position: absolute;
            -webkit-animation: ai 4s linear 0s infinite;
            animation: ai 4s linear 0s infinite;
            left: 70px;
            top: 24px;
          }
        }
      }
    }
    // dl {
    //   height: 100%;
    //   padding: 0 60px;
    //   dd {
    //     padding-top: 15px;
    //     margin: 0 auto;
    //     text-align: center;
    //     font-size: 20px;
    //     font-family: Microsoft YaHei;
    //     font-weight: bold;
    //     color: rgba(46, 47, 49, 1);
    //   }
    // }
    // dl:hover {
    //   transform: scale(1.1);
    //   cursor: pointer;
    // }
  }
  .main_swiper {
    height: 630px;
    background: #f3f7fb;
    .swiper_1 {
      height: 100%;
      display: flex;
      justify-content: space-around;
      padding: 0 300px;
      .swiper_left {
        display: flex;
        flex-direction: column;
        align-items: center;
        h3 {
          margin-top: 192px;
          width: 520px;
          font-size: 40px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #000000;
        }
        p {
          margin-top: 44px;
          width: 507px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #686868;
        }
      }
      .swiper_right {
        position: relative;
        .swiper1 {
          width: 630px;
          height: 570px;
        }
        .position {
          position: absolute;
          -webkit-animation: ai 3s linear 0s infinite;
          animation: ai 3s linear 0s infinite;
          &:nth-of-type(even) {
            animation: ai 2s linear 0s infinite;
          }
          &:nth-of-type(odd) {
            animation: ai 4s linear 0s infinite;
          }
        }
        p {
          width: 7px;
          height: 7px;
          background: #83c1fd;
          border-radius: 50%;
          position: absolute;
        }
        .p1 {
          background: #60acff;
          top: 286px;
          left: 198px;
          animation: 1s 0s linear infinite ai3, 0.5s 0s linear infinite opacity1;
          -webkit-animation: 1s 0s linear infinite ai3,
            0.5s 0s linear infinite opacity1;
        }
        .p2 {
          top: 374px;
          left: 56px;
          animation: 1s 0s linear infinite ai4, 1s 0s linear infinite opacity1;
          -webkit-animation: 1s 0s linear infinite ai4,
            1s 0s linear infinite opacity1;
          animation-delay: 1s;
          -webkit-animation-delay: 1s;
        }
        .p3 {
          top: 388px;
          left: 39px;
          animation: 1s 0s linear infinite ai5, 1s 0s linear infinite opacity1;
          -webkit-animation: 1s 0s linear infinite ai5,
            1s 0s linear infinite opacity1;
          animation-delay: 2s;
          -webkit-animation-delay: 2s;
        }
        .p4 {
          top: 483px;
          left: 200px;
          animation: 1s 0s linear infinite ai6, 0.5s 0s linear infinite opacity1;
          -webkit-animation: 1s 0s linear infinite ai6,
            0.5s 0s linear infinite opacity1;
          animation-delay: 3s;
          -webkit-animation-delay: 3s;
        }
        .l1 {
          left: 223px;
          top: 241px;
          animation: 1s 0s linear infinite l1, 0.5s 0s linear infinite opacity1;
          -webkit-animation: 1s 0s linear infinite l1,
            0.5s 0s linear infinite opacity1;
        }
        .l2 {
          left: 148px;
          top: 193px;
          animation: 1s 0s linear infinite l2, 0.5s 0s linear infinite opacity1;
          -webkit-animation: 1s 0s linear infinite l2,
            0.5s 0s linear infinite opacity1;
          animation-delay: 1s;
          -webkit-animation-delay: 1s;
        }
        .l3 {
          top: 275px;
          left: 3px;
          animation: 1s 0s linear infinite l3, 0.5s 0s linear infinite opacity1;
          -webkit-animation: 1s 0s linear infinite l3,
            0.5s 0s linear infinite opacity1;
          animation-delay: 2s;
          -webkit-animation-delay: 2s;
        }
        .l4 {
          top: 361px;
          left: 143px;
          animation: 1s 0s linear infinite l4, 0.5s 0s linear infinite opacity1;
          -webkit-animation: 1s 0s linear infinite l4,
            0.5s 0s linear infinite opacity1;
          animation-delay: 3s;
          -webkit-animation-delay: 3s;
        }
        .l5 {
          top: 445px;
          left: 377px;
          animation: 1s 0s linear infinite l5, 0.5s 0s linear infinite opacity1;
          -webkit-animation: 1s 0s linear infinite l5,
            0.5s 0s linear infinite opacity1;
          animation-delay: 4s;
          -webkit-animation-delay: 4s;
        }
        .posi {
          position: relative;
          width: 18px;
          height: 150px;
          position: absolute;
          span {
            position: absolute;
            display: block;
            width: 2px;
            height: 2px;
            background: #5dd6e8;
            -webkit-animation: ai2 0.8s linear 0s infinite;
            animation: ai2 0.8s linear 0s infinite;
            &:nth-child(even) {
              animation-duration: 0.3s;
            }
          }
        }
      }
    }
  }
  .advanSeachBox {
    width: auto;
    height: auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    .searchBox_1 {
      width: 100%;
      height: auto;
      display: flex;
      border-bottom: thin solid #dfdfdf;
      margin-top: 20px;
      .searchBox_1_left {
        height: 78px;
        text-align: center;
      }
      .searchBox_1_right {
        height: 78px;
        margin-left: 20px;
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        div {
          width: auto;
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin: 0 7px 12px 0;
          border: 1px solid #eee;
          height: 30px;
          background: #ffffff;
          border: 1px solid #85bff9;
          border-radius: 2px;
          padding: 6px 8px;
          box-sizing: border-box;
          p {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #177fe8;
            span {
              color: #4d4d4d;
            }
          }
          i {
            color: #177fe8;
            font-size: 14px;
            margin-left: 3px;
          }
        }
      }
      .searchBox_1_right_auto {
        height: auto;
        margin-left: 20px;
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        div {
          width: auto;
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin: 0 7px 12px 0;
          border: 1px solid #eee;
          height: 30px;
          background: #ffffff;
          border: 1px solid #85bff9;
          border-radius: 2px;
          padding: 6px 8px;
          box-sizing: border-box;
          p {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #177fe8;
            span {
              color: #4d4d4d;
            }
          }
          i {
            color: #177fe8;
            font-size: 14px;
            margin-left: 3px;
          }
        }
      }
    }
    .btn-show {
      width: 100%;
      text-align: center;
    }
    .searchBox_2 {
      width: 100%;
      margin-top: 20px;
      height: auto;
      border-bottom: thin solid #dfdfdf;
      padding-bottom: 10px;
      .searchBox_2_right {
        margin-top: 7px;
      }
      .searchBox_2_left,
      .searchBox_2_right {
        width: 432px;
        display: flex;

        /deep/ .el-cascader {
          margin-left: 20px;
          flex: 1;
        }
      }
      .searchBox_2_title {
        line-height: 40px;
        text-align: center;
      }
    }
    .searchBox_3 {
      margin-top: 20px;
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      p {
        height: 40px;
        font-size: 14px;
        text-align: center;
        line-height: 40px;
      }
    }
    .searchBox_4 {
      margin-top: 20px;
      width: 100%;
      height: 82px;
      display: flex;
      border-bottom: thin solid #dfdfdf;
      padding-bottom: 5px;
      .searchBox_4_left {
        height: 80px;
        text-align: center;
        line-height: 80px;
      }
      .searchBox_4_right {
        flex: 1;
        display: flex;
        flex-direction: column;
        .select_box {
          margin-top: 4px;
        }
        div {
          display: flex;
          /deep/ .el-select {
            margin-left: 20px;
          }
        }
      }
    }
  }
  .dialog-footer {
    text-align: center;
  }
  /deep/ .el-dialog {
    padding: 0 30px;
    width: 1200px !important;
  }
  /deep/ .el-dialog__title {
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
  /deep/ .el-dialog__body {
    padding: 18px 25px 30px;
  }
  /deep/ .el-dialog__body .dialog_title {
    width: 100%;
    text-align: center;
    height: 45px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #808080;
    border-bottom: 1px solid #dfdfdf;
  }
  /deep/ .el-dialog--center {
    margin-top: 10vh !important;
  }
  /deep/ .el-radio {
    height: 40px;
    line-height: 40px;
  }
  /deep/ .el-radio-group {
    display: flex;
    align-items: center;
    border-bottom: thin solid #dfdfdf;
    flex-wrap: wrap;
  }
  /deep/ .el-carousel__arrow--left {
    display: none;
  }
  /deep/ .el-carousel__arrow--right {
    display: none;
  }
  /deep/ .el-carousel__button {
    width: 24px;
    height: 4px;
    background: #2481d9;
    border-radius: 2px;
  }
  /deep/ .el-radio__inner {
    display: none;
  }
}
video {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  // height: 100%;
  // min-width: 100%;
  // min-height: 100%;
  height: auto;
  // width: auto;
  /*加滤镜*/
  /*filter: blur(15px); //背景模糊设置 */
  /*-webkit-filter: grayscale(100%);*/
  /*filter:grayscale(100%); //背景灰度设置*/
  z-index: -11;
}
source {
  min-width: 100%;
  min-height: 100%;
  height: auto;
  width: auto;
}

@keyframes ai {
  0% {
    margin-top: 0;
  }
  50% {
    margin-top: -10px;
  }
  100% {
    margin-top: 0;
  }
}
@-webkit-keyframes ai {
  0% {
    margin-top: 0;
  }
  50% {
    margin-top: -20px;
  }
  100% {
    margin-top: 0;
  }
}
@keyframes ai2 {
  0% {
    opacity: 1;
    margin-top: 0;
  }

  100% {
    opacity: 0;
    margin-top: -8px;
  }
}
@-webkit-keyframes ai2 {
  0% {
    opacity: 1;
    margin-top: 0;
  }

  100% {
    opacity: 0;
    margin-top: -8px;
  }
}
@keyframes ai3 {
  0% {
    top: 286px;
    left: 198px;
  }

  to {
    top: 316px;
    left: 151px;
  }
}
@keyframes ai4 {
  0% {
    top: 374px;
    left: 56px;
  }

  to {
    top: 386px;
    left: 40px;
  }
}
@keyframes ai5 {
  0% {
    top: 388px;
    left: 39px;
  }

  to {
    top: 486px;
    left: 200px;
  }
}
@keyframes ai6 {
  0% {
    top: 486px;
    left: 200px;
  }

  to {
    top: 439px;
    left: 273px;
  }
}
@-webkit-keyframes ai3 {
  0% {
    top: 286px;
    left: 198px;
  }

  to {
    top: 316px;
    left: 151px;
  }
}
@-webkit-keyframes ai4 {
  0% {
    top: 374px;
    left: 56px;
  }

  to {
    top: 386px;
    left: 40px;
  }
}
@-webkit-keyframes ai5 {
  0% {
    top: 388px;
    left: 39px;
  }

  to {
    top: 483px;
    left: 200px;
  }
}
@-webkit-keyframes ai6 {
  0% {
    top: 483px;
    left: 200px;
  }

  to {
    top: 439px;
    left: 273px;
  }
}
@keyframes opacity1 {
  0%,
  100% {
    opacity: 0.05;
  }
  40%,
  60% {
    opacity: 1;
  }
}
@-webkit-keyframes opacity1 {
  0%,
  100% {
    opacity: 0.05;
  }
  40%,
  60% {
    opacity: 1;
  }
}
@keyframes l1 {
  0% {
    left: 223px;
    top: 241px;
  }

  to {
    left: 148px;
    top: 195px;
  }
}
@keyframes l2 {
  0% {
    left: 148px;
    top: 193px;
  }

  to {
    top: 275px;
    left: 5px;
  }
}
@keyframes l3 {
  0% {
    top: 275px;
    left: 3px;
  }

  to {
    left: 46px;
    top: 308px;
  }
}
@keyframes l4 {
  0% {
    top: 361px;
    left: 143px;
  }

  to {
    top: 446px;
    left: 271px;
  }
}
@keyframes l5 {
  0% {
    top: 445px;
    left: 377px;
  }

  to {
    top: 364px;
    left: 501px;
  }
}
@-webkit-keyframes l1 {
  0% {
    left: 223px;
    top: 241px;
  }

  to {
    left: 148px;
    top: 195px;
  }
}
@-webkit-keyframes l2 {
  0% {
    left: 148px;
    top: 193px;
  }

  to {
    top: 275px;
    left: 5px;
  }
}
@-webkit-keyframes l3 {
  0% {
    top: 275px;
    left: 3px;
  }

  to {
    left: 46px;
    top: 308px;
  }
}
@-webkit-keyframes l4 {
  0% {
    top: 361px;
    left: 143px;
  }

  to {
    top: 446px;
    left: 271px;
  }
}
@-webkit-keyframes l5 {
  0% {
    top: 445px;
    left: 377px;
  }

  to {
    top: 364px;
    left: 501px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Index/index.vue